import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("nourish_admin_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error?.response?.status === 401 && window.location.pathname.startsWith("/admin")) {
      localStorage.removeItem("nourish_admin_token");
      localStorage.removeItem("nourish_admin");
      if (!window.location.pathname.includes("/admin/login")) {
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(error);
  }
);

export default api;

export const getToken = () => localStorage.getItem("nourish_admin_token");
export const setAuth = (token, admin) => {
  localStorage.setItem("nourish_admin_token", token);
  localStorage.setItem("nourish_admin", JSON.stringify(admin));
};
export const getAdmin = () => {
  try {
    return JSON.parse(localStorage.getItem("nourish_admin") || "null");
  } catch {
    return null;
  }
};
export const clearAuth = () => {
  localStorage.removeItem("nourish_admin_token");
  localStorage.removeItem("nourish_admin");
};

export const slugifyName = (name) => {
  const s = (name || "")
    .toLowerCase()
    .replace(/[^\w\s-]/g, "")
    .trim()
    .replace(/\s+/g, "-")
    .slice(0, 40);
  return s || "client";
};

export const clientPath = (name, token, suffix = "") =>
  `/${slugifyName(name)}/${token}${suffix}`;
